var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelevision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeLinejoin: "round",
    width: 18,
    height: 13,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M9 17v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18h14"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E %3Cg transform='translate(3 3)' stroke='%23000' stroke-width='2' fill='none' fill-rule='evenodd'%3E %3Crect stroke-linejoin='round' width='18' height='13' rx='1'/%3E %3Cpath stroke-linecap='square' d='M9 17v-2'/%3E %3Cpath d='M2 18h14'/%3E %3C/g%3E %3C/svg%3E";
export { SvgTelevision as ReactComponent };